import React from 'react';
import { IonButton, IonInput, IonItem, IonList } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import './AddVirtualFarecardForm.css';
import image from './VirtualFarecard.svg';
import VisualFarecard from "./VisualFarecard";
import {uiInputMode} from "../../utils/ui";

type AddVirtualFarecardFormProps = {
  isValid: boolean;
  name: string;
  setName: (s: string) => void;
  proceed: () => void;
};

export default function AddVirtualFarecardForm({
  isValid,
  name,
  setName,
  proceed,
}: AddVirtualFarecardFormProps) {
  const [t] = useTranslation('global');

  return (
    <>
      <p className="pt-2 pb-3 px-2 instructions ion-text-center">
        {t('farecards.virtualinfo')}
      </p>
      <div className="ion-text-center farcards-physical">
          <VisualFarecard item={{ isVirtualCard: true }} />
      </div>
      <h1 className="h1 pt-5">{t('farecards.name')}</h1>
      <IonList inset={false}>
        <IonItem lines="none" className="ion-no-padding">
          <IonInput
            value={name}
            mode={uiInputMode()}
            aria-label={t('farecards.name')!}
            placeholder={t('farecards.name')!}
            onIonInput={(e) => setName(e.detail.value!)}
            type="text"
            fill="outline"
          ></IonInput>
        </IonItem>
        <IonItem lines="none" className="ion-no-padding form-field-hint">
          {t('farecards.hintname')}
        </IonItem>
      </IonList>

      <p className="pt-2 pb-2 farecards-fareinfo instructions">
        <a href={t('farecards.fareinfolink')!} rel={'noreferrer'} target={'_blank'}>
          {t('farecards.fareinfolinkname')}
        </a>
      </p>

      <div className="pt-3 ion-text-center">
        <IonButton
          className={
            'btn-default btn-wide-80 ' + (isValid ? '' : 'btn-disabled')
          }
          onClick={() => proceed()}
        >
          {t('farecards.addcard')}
        </IonButton>
      </div>
    </>
  );
}
